/**
 * @generated SignedSource<<591623097ff3deede4d80df2c47bd771>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Basket",
    "kind": "LinkedField",
    "name": "basketById",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "notes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BasketPick",
        "kind": "LinkedField",
        "name": "picks",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Endpoint",
            "kind": "LinkedField",
            "name": "endpoint",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "initialQuantity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quantity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Service",
            "kind": "LinkedField",
            "name": "service",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "impulseOPLCheckoutPagesBasketByIdQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "impulseOPLCheckoutPagesBasketByIdQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "9cd8a89509899beff861d3fe00bed5b5",
    "id": null,
    "metadata": {},
    "name": "impulseOPLCheckoutPagesBasketByIdQuery",
    "operationKind": "query",
    "text": "query impulseOPLCheckoutPagesBasketByIdQuery(\n  $id: String\n) {\n  basketById(id: $id) {\n    id\n    notes\n    picks {\n      endpoint {\n        id\n      }\n      initialQuantity\n      quantity\n      service {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "f1af4dfaa9d4a0adddb61fbba486ab06";

module.exports = node;
